import React from 'react';
import PropTypes from 'prop-types';
import { formatNoticePeriod } from './tabFormatters';

// "Location & Availability" column — New tab only (senior_level_flow), wired
// in via seniorFlowTabFactory's `extraColumns`. Two stacked lines, matching
// the shared screenshot's "LOCATION & AVAILABILITY" list:
//   - the candidate's current location (bold)
//   - their notice period (muted)
// The screenshot also shows experience on the second line — deliberately
// omitted here, it already lives in the Candidate column's Recent Job Info
// line (see CandidateCell.jsx).
//
// Field names confirmed against a real candidate-list response
// (`location_name`, `notice_period` in whole days). Both lines degrade
// gracefully: no location → line hidden; no notice_period → "Notice period
// not shared yet".
const LOCATION_AVAILABILITY_FIELDS = {
  location: 'location_name',
  noticePeriodDays: 'notice_period',
};

const LocationAvailabilityCell = ({ row }) => {
  const location = row[LOCATION_AVAILABILITY_FIELDS.location];
  const noticeText = formatNoticePeriod(
    row[LOCATION_AVAILABILITY_FIELDS.noticePeriodDays]
  );

  return (
    <div className="min-w-0">
      {location && (
        <p className="text-sm font-semibold text-foreground-strong truncate">
          {location}
        </p>
      )}
      <p className="text-xs text-muted-foreground truncate">{noticeText}</p>
    </div>
  );
};

LocationAvailabilityCell.propTypes = {
  row: PropTypes.shape({
    location_name: PropTypes.string,
    notice_period: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
};

export const locationAvailabilityColumn = {
  key: 'location_availability',
  header: 'Location & Availability',
  className: 'text-sm',
  // Left-aligned per explicit request — every senior_level_flow column
  // reads left-to-right like the Candidate column, for a consistent
  // layout across tabs. LocationAvailabilityCell's own markup is plain
  // block text (no internal flex row fighting this), so the column-level
  // align is all that's needed here.
  align: 'left',
  // Narrow-ish fixed width, same rationale as sharedColumns.js: under
  // DataTable's `table-fixed`, unsized columns split width equally and
  // crush the Candidate column.
  width: '200px',
  render: (_v, row) => <LocationAvailabilityCell row={row} />,
};

export default LocationAvailabilityCell;
